module.exports = __webpack_public_path__ + "static/media/27_B.4dc6812f.png";